import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Flex } from 'components/ui';
import { MAX_PRODUCTS } from 'components/Catalog/ProductGrid/CompareModal/constants';
import { zoneStyles } from 'components/Catalog/ProductGrid/CompareModal/Zones/zoneStyles';
import {
    colors, space, mediaQueries, shadows
} from 'style/config';
import ProductCardItem from 'components/Catalog/ProductGrid/CompareModal/Zones/ProductCardZone/ProductCardItem';

const ProductCardZone = ({
    comparisonData = [], getText = () => {}, handleProductRemove = () => {}, scrollRef, onScroll, isCompact = false
}) => {
    const renderProductSlot = (product, index) => {
        const currentProduct = product?.parentProducts?.[0];
        const slotKey = currentProduct?.productId ? `product-${currentProduct?.productId}` : `slot-${index}`;

        return (
            <Box
                key={slotKey}
                css={isCompact ? { ...zoneStyles.productSlot, ...zoneStyles.productSlotCompact } : zoneStyles.productSlot}
                data-at={Sephora.debug.dataAt(`compare_modal_product_slot_${index + 1}`)}
                aria-hidden={!product ? 'true' : undefined}
            >
                {product && (
                    <ProductCardItem
                        product={product}
                        currentProduct={currentProduct}
                        index={index}
                        isCompact={isCompact}
                        getText={getText}
                        handleProductRemove={handleProductRemove}
                    />
                )}
            </Box>
        );
    };

    return (
        <Box
            ref={scrollRef}
            css={[styles.stickyProductCardSection, isCompact && styles.stickyProductCardSectionCompact]}
            onScroll={onScroll}
        >
            <Flex css={zoneStyles.productsContainer}>
                {Array.from({ length: MAX_PRODUCTS }, (_, index) => {
                    const product = comparisonData?.skus?.[index];

                    return renderProductSlot(product, index);
                })}
            </Flex>
        </Box>
    );
};

const styles = {
    stickyProductCardSection: {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: colors.white,
        paddingTop: `${space[5]}px`,
        paddingBottom: `${space[2]}px`,
        paddingRight: `${space[4]}px`,
        overflowX: 'scroll',
        overflowY: 'hidden',
        // Hide scrollbars but allow scrolling
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        transition: 'padding 0.3s ease',
        [mediaQueries.sm]: {
            paddingRight: `${space[4]}px`
        }
    },
    stickyProductCardSectionCompact: {
        paddingTop: `${space[2]}px`,
        paddingBottom: `${space[2]}px`,
        boxShadow: shadows.light,
        marginLeft: `-${space[4]}px`,
        paddingLeft: `${space[4]}px`,
        marginRight: `-${space[4]}px`,
        marginBottom: 0,
        transition:
            'padding-top 0.3s ease, padding-bottom 0.3s ease, padding-left 0.3s ease, margin-left 0.3s ease, margin-right 0.3s ease, margin-bottom 0.3s ease, box-shadow 0.3s ease'
    }
};

ProductCardZone.propTypes = {
    selectedProducts: PropTypes.arrayOf(PropTypes.object),
    comparisonData: PropTypes.object,
    getText: PropTypes.func,
    handleProductRemove: PropTypes.func,
    scrollRef: PropTypes.object,
    onScroll: PropTypes.func,
    isCompact: PropTypes.bool
};

export default wrapFunctionalComponent(ProductCardZone, 'ProductCardZone');
